import { Link } from 'react-router-dom';

/** Shared identity for the campaign, with a direct home link for each partner. */
export function CampaignPartners() {
  return <div className="tim-partners" aria-label="CMJ Cinema and ETDS Detroit">
    <Link to="/" className="tim-partner-cmj" aria-label="CMJ Cinema home">
      <span>cmj<span>.</span></span><small>CINEMA</small>
    </Link>
    <span className="tim-partner-cross" aria-hidden="true">×</span>
    <a className="tim-partner-etds" href="https://etdsdetroit.com/" target="_blank" rel="noopener noreferrer" aria-label="ETDS Detroit — visit their website (opens in a new tab)">
      <img src="/images/this-is-me/etds-logo.png" alt="ETDS Detroit" width="92" height="81" />
    </a>
  </div>;
}
